import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { animated, useSpring } from 'react-spring';
import { deviceSelector, handleNewUser } from '../../entities/UserSlice';
import ButtonBlack from '../../features/button-black/ButtonBlack';
import ROUTES from '../../layout/routes';
import Portal from '../../shared/portal/Portal';
import styles from './CookiePopup.module.scss';

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

const CookiePopup = () => {
  const newUserName = 'moments_user';
  const device = useSelector(deviceSelector);
  const newUserDate =
    new Date().toLocaleDateString() +
    '/' +
    new Date().getHours() +
    '/' +
    new Date().getMinutes() +
    '/' +
    new Date().getSeconds();
  const dispatch = useDispatch();

  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setToggle(true);
    }, 2000);
  }, []);

  const animatedStyle = useSpring({
    config: {
      duration: 800,
      mass: 1,
      tension: 280,
      friction: 120,
    },
    top: toggle
      ? window.innerHeight - (134 / 1600) * window.innerWidth
      : window.innerHeight + (300 / 1600) * window.innerWidth,

    delay: 0,
  });

  const animatedStyleMobile = useSpring({
    config: {
      duration: 800,
      mass: 1,
      tension: 280,
      friction: 120,
    },
    top: toggle
      ? window.innerHeight - (134 / 375) * window.innerWidth
      : window.innerHeight + (300 / 375) * window.innerWidth,

    delay: 0,
  });

  return (
    <Portal>
      <animated.div
        data-scroll
        data-scroll-sticky
        data-scroll-target='#fixed-target'
        className={styles.container}
        style={device !== 'isMobile' ? animatedStyle : animatedStyleMobile}
      >
        <div className={styles.text}>
          Нажимая на эту кнопку, вы соглашаетесь с нашей{' '}
          <Link to={ROUTES.privacy} rel='noopener noreferrer' target='_blank'>
            <span>политикой конфиденциальности</span>
          </Link>{' '}
          и даёте согласие на обработку персональных данных.
        </div>
        <ButtonBlack
          className={styles.btn}
          handleFuction={() => {
            setCookie(newUserName, newUserDate, 365);
            dispatch(handleNewUser({ isANewUser: 'new', value: true }));
          }}
          text='Согласен'
        />
      </animated.div>
    </Portal>
  );
};

export default CookiePopup;
